import { render, staticRenderFns } from "./emailViewer.vue?vue&type=template&id=26d8587e&scoped=true"
import script from "./emailViewer.vue?vue&type=script&lang=js"
export * from "./emailViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d8587e",
  null
  
)

/* custom blocks */
import block0 from "./emailViewer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports